<template>
  <el-col :span="24">
    <div
      class="ma-0"
      v-loading="loading"
      :element-loading-spinner="svg"
      element-loading-svg-view-box="-10, -10, 50, 50"
      element-loading-background="rgba(122, 122, 122, 0.8)"
    >
    <div class="custom-table-design">
      <el-table
        :data="userDataList"
        :fit="true"
        height="650"
        stripe
        :row-class-name="tableRowClassName"
        @row-click="handleRowClick"
        class="my-2 data-table"
        scrollbar-always-on: false
      >
        <el-table-column
          :label="'Monitoring Period'"
          :prop="'monitoring_period_id'"
          :width="$vuetify.display.width <= 2700 ? 250 : ''"
          sortable
        >
          <template #default="scope">
            {{ scope.row.monitoring_period_id == null ? "" : monitoringPeriods.find(mp => mp.id == scope.row.monitoring_period_id).name }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Charging Site'"
          :prop="'charging_site_title'"
          :width="$vuetify.display.width <= 2700 ? 250 : ''"
          sortable
        />
        <el-table-column
          :label="'Country'"
          :prop="'country'"
          :width="$vuetify.display.width <= 2700 ? 200 : ''"
          sortable
        />
        <el-table-column
          :label="'Dispatch Int'"
          :prop="'dispatch_int'"
          :width="$vuetify.display.width <= 2700 ? 200 : ''"
          sortable
        />
        <el-table-column
          :label="'Charger Type'"
          :prop="'charger_type'"
          :width="$vuetify.display.width <= 2700 ? 200 : ''"
          sortable
        />
        <el-table-column
          :label="'Fuel Emission Intensity'"
          :prop="'fuel_emission_intensity'"
          :width="$vuetify.display.width <= 2700 ? 250 : ''"
          sortable
        />
        <el-table-column
          :label="'Afec'"
          :prop="'afec'"
          :width="$vuetify.display.width <= 2700 ? 250 : ''"
          sortable
        />
        <el-table-column
          :label="'Mpg'"
          :prop="'mpg'"
          :width="$vuetify.display.width <= 2700 ? 250 : ''"
          sortable
        />
        <el-table-column
          :label="'Charger Efficiency'"
          :prop="'charger_efficiency'"
          :width="$vuetify.display.width <= 2700 ? 250 : ''"
          sortable
        />
        <el-table-column
          :label="'Improvement Rate'"
          :prop="'tech_improvement_rate'"
          :width="$vuetify.display.width <= 2700 ? 300 : ''"
          sortable
        />
        <el-table-column
          :label="'Fuel Energy Density MJ gal'"
          :prop="'fuel_energy_density_MJ_gal'"
          :width="$vuetify.display.width <= 2700 ? 300 : ''"
          sortable
        />
        <el-table-column
          :label="'Fuel Energy Density MJ kWh'"
          :prop="'fuel_energy_density_MJ_kWh'"
          :width="$vuetify.display.width <= 2700 ? 300 : ''"
          sortable
        />

        <el-table-column
          v-if="
            $vuetify.display.width < 500 &&
            $store.state.auth.user != null &&
            !$store.state.auth.user.is_auditor
          "
          :label="'Actions'"
          :prop="'operations'"
          align="center"
          width="150"
        >
          <template #default="scope">
            <el-tooltip placement="top" effect="light">
                <template #content>Edit</template>
                <el-button
                  v-if="
                    scope.row.id != null && scope.row.id != ''
                  "
                  @click.stop="handleShow(scope.$index, scope.row)"
                  size="small"
                  class="height-25 rounded-2 m-0 ml-2"
                  color="#DDF0AC"
                  style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                >
                    <svg style="width: 24px; height: 24px;">
                        <use href="@/assets/svg/newSvgIcon.svg#tableOperationEdit"></use>
                    </svg>
                </el-button>
              </el-tooltip>

              <el-tooltip placement="top" effect="light">
                <template #content>Delete</template>
                <el-button
                  v-if="
                    scope.row.id != null && scope.row.id != ''
                  "
                  @click.stop="deleteRow(scope.row, scope.$index)"
                  size="small"
                  class="height-25 rounded-2 m-0 ml-2"
                  color="#DDF0AC"
                  style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                >
                    <svg style="width: 24px; height: 24px;">
                        <use href="@/assets/svg/newSvgIcon.svg#tableOperationDelete"></use>
                    </svg>
                </el-button>
              </el-tooltip>

              <el-tooltip placement="top" effect="light">
                <template #content>Copy</template>
                <el-button
                  v-if="
                    scope.row.id != null && scope.row.id != ''
                  "
                  @click.stop="copyRow(scope.row, scope.$index)"
                  size="small"
                  class="height-25 rounded-2 m-0 ml-2"
                  color="#DDF0AC"
                  style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                >
                    <svg style="width: 24px; height: 24px;">
                        <use href="@/assets/svg/newSvgIcon.svg#make-a-copy-btn"></use>
                    </svg>
                </el-button>
              </el-tooltip>

          </template>
        </el-table-column>
        <el-table-column
          v-else-if="
            $store.state.auth.user != null && !$store.state.auth.user.is_auditor
          "
          fixed="right"
          :label="'Actions'"
          :prop="'operations'"
          align="center"
          width="150"
        >
          <template #default="scope">
            <el-tooltip placement="top" effect="light">
                <template #content>Edit</template>
                <el-button
                  v-if="
                    scope.row.id != null && scope.row.id != ''
                  "
                  @click.stop="handleShow(scope.$index, scope.row)"
                  size="small"
                  class="height-25 rounded-2 m-0 ml-2"
                  color="#DDF0AC"
                  style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                >
                    <svg style="width: 24px; height: 24px;">
                        <use href="@/assets/svg/newSvgIcon.svg#tableOperationEdit"></use>
                    </svg>
                </el-button>
              </el-tooltip>

              <el-tooltip placement="top" effect="light">
                <template #content>Delete</template>
                <el-button
                  v-if="
                    scope.row.id != null && scope.row.id != ''
                  "
                  @click.stop="deleteRow(scope.row, scope.$index)"
                  size="small"
                  class="height-25 rounded-2 m-0 ml-2"
                  color="#DDF0AC"
                  style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                >
                    <svg style="width: 24px; height: 24px;">
                        <use href="@/assets/svg/newSvgIcon.svg#tableOperationDelete"></use>
                    </svg>
                </el-button>
              </el-tooltip>

              <el-tooltip placement="top" effect="light">
                <template #content>Copy</template>
                <el-button
                  v-if="
                    scope.row.id != null && scope.row.id != ''
                  "
                  @click.stop="copyRow(scope.row, scope.$index)"
                  size="small"
                  class="height-25 rounded-2 m-0 ml-2"
                  color="#DDF0AC"
                  style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                >
                    <svg style="width: 24px; height: 24px;">
                        <use href="@/assets/svg/newSvgIcon.svg#make-a-copy-btn"></use>
                    </svg>
                </el-button>
              </el-tooltip>


          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="custom-pagination" v-if="$vuetify.display.width >= 700">
      <el-row class="row-bg" justify="space-between">
        <el-col
          :span="5"
          class="d-flex justify-content-start align-items-center"
        >
          <el-select
            v-model="perPageCount"
            placeholder="Select"
            size="small"
            style="width: 70px"
          >
                        <el-option label="10" :value="'10'" />
                        <el-option label="25" :value="'25'" />
                        <el-option label="50" :value="'50'" />
                        <el-option label="100" :value="'100'" />
                        <el-option label="500" :value="'500'" />
                        <el-option label="1k" :value="'1000'" />
          </el-select>
        </el-col>
        <el-col
          :span="8"
          class="d-flex align-items-center justify-content-center"
        >
          <el-pagination
            small
            background
            layout="prev, pager, next"
            :total="total_items"
            v-model:page-size="page_size"
            v-model:current-page="current_page"
            @current-change="changePage"
            class="my-4"
          />
        </el-col>
        <el-col :span="5" class="d-flex justify-content-end align-items-center">
          <!-- <span class="text-white">
            {{ (current_page - 1) * perPageCount + 1 }}-{{
              current_page * perPageCount > total_items
                ? total_items
                : current_page * perPageCount
            }}
            of {{ total_items }}
          </span> -->
          <span class="text-white">
            {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
              current_page * perPageCount > total_items
                ? total_items.toLocaleString()
                : (current_page * perPageCount).toLocaleString()
            }}
            of {{ total_items.toLocaleString() }}
          </span>
        </el-col>
      </el-row>
    </div>

    <div class="custom-pagination" v-if="$vuetify.display.width < 700">
      <el-row class="row-bg" justify="space-between">
        <el-col
          :span="24"
          class="d-flex align-items-center justify-content-center"
        >
          <el-pagination
            small
            background
            layout="prev, pager, next"
            :total="total_items"
            v-model:page-size="page_size"
            v-model:current-page="current_page"
            @current-change="changePage"
            class="my-4"
          />
        </el-col>
        <el-col
          :span="10"
          class="d-flex justify-content-end align-items-center"
        >
          <el-select
            v-model="perPageCount"
            placeholder="Select"
            size="small"
            style="width: 70px"
          >
                        <el-option label="10" :value="'10'" />
                        <el-option label="25" :value="'25'" />
                        <el-option label="50" :value="'50'" />
                        <el-option label="100" :value="'100'" />
                        <el-option label="500" :value="'500'" />
                        <el-option label="1k" :value="'1000'" />
          </el-select>
        </el-col>
        <el-col :span="5" class="d-flex justify-content-start align-items-center">
          <span class="text-white">
            {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
              current_page * perPageCount > total_items
                ? total_items.toLocaleString()
                : (current_page * perPageCount).toLocaleString()
            }}
            of {{ total_items.toLocaleString() }}
          </span>
        </el-col>
      </el-row>
    </div>

    </div>
  </el-col>
</template>

<script>
// import { ElMessageBox } from "element-plus";
// import ShowDetail from "./dialogDetail.vue";
// import UserService from "../../services/user.service";
export default {
  props: {
    loadingProp: {
      type: Boolean,
      default: false,
    },
    usersDataProp: {
      type: Array,
      default(rawProps) {
        return rawProps;
      },
    },
    totalRowProp: {
      type: Number,
    },
    monitoringPeriodsProp: {
      type: Array,
      default(rawProps) {
        return rawProps;
      },
    },
  },
  components: {
    // ShowDetail,
  },
  data() {
    return {
      show: true,
      userDataList: [],
      monitoringPeriods: [],
      search: "",
      current_page: 1,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,
      loading: false,
      show_modal: false,
      data_modal: null,
      current_row_index: null,
      filterOpen: false,
    };
  },
  watch: {
    monitoringPeriodsProp: {
      handler: function (newValue) {
        this.monitoringPeriods = newValue;
      },
      deep: true,
    },
    loadingProp: {
      handler: function (newValue) {
        this.loading = newValue;
      },
      deep: true,
    },
    usersDataProp: {
      handler: function (newValue) {
        this.userDataList = newValue;
      },
      deep: true,
    },
    totalRowProp: {
      handler: function (newValue) {
        this.current_page = 1;
        this.total_items = newValue;
        console.log(this.total_items);
      },
      deep: true,
    },
    perPageCount: function (newVal) {
      this.current_page = 1;
      this.page_size = parseInt(newVal);
      this.$emit("tableAction", {
        index: this.page_size,
        data: null,
        kind: "perPageChange",
      });
    },
  },
  methods: {
    handleRowClick(row, column, event) {
      console.log(row, column, event);
    },
    handleShow(index, data) {
      this.$emit("tableAction", { index: index, data: data, kind: "edit" });
    },
    deleteRow(event, index) {
      this.$emit("tableAction", { index: index, data: event, kind: "delete" });
    },
    copyRow(event, index) {
      this.$emit("tableAction", { index: index, data: event, kind: "copy" });
    },
    changePage(page) {
      this.$emit("tableAction", {
        index: page,
        data: null,
        kind: "changePage",
      });
    },
  },
};
</script>
